import { fKeyTabInput } from "../../../Utility/Utilitys";
import {
  CmpTypographyField,
 
} from "../../../Component/Common/ToolBox/ToolBox";

import Grid from "@mui/material/Grid";
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCContent({
  sCurrentStock,
  sAdjTypeDependency,
  fFocusShowSalesHistoryGrid,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,
  vRdxWmsHead,
  xBufferObj,
  sUnit,

  fUnit,
  fUnitCost,
  fUnitCostSave_onKeyUp,
  fAdjType,
  sAdjType,
  fOpenContentItemSearchModalKey,
  fQty,
  fItemName,
  fCardId,
  fCardIdEnter,
  fBatch,
  fMDF,
  fEXD,
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,

  //customer
  xfGC_Toggle_Head_BinName_Name,
  xGC_Toggle_Head_BinName_Toggle = false,
  xGC_Toggle_Head_BinName_onKeyUp,
  xGC_Toggle_Head_BinName_SearchDropdownObj,
  xGC_Toggle_Head_BinName_Dropdown_onChange,
  xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_GridData,
  xfGC_Toggle_Head_BinName_OnRowClick,
  xfGC_Toggle_Head_BinName_OnCellKeyDown,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  //customer end
}) {
  return (
    <form className="Wms-inbound-grn-content" id="WmsStockAdjustmentContent">
      <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid item xs={12} sm={6} md={6}>
            {xMediaQuery ? (
              <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className={
                  vRdxWmsHead.A_DocStat == "POST"
                    ? "hide-all-time"
                    : "d-flex justify-content-between align-items-center"
                }
              >
                <Grid item xs={6}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"StockQty= " + sCurrentStock.A_CurrentStockQty + ""}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={
                      "StockValue= " + sCurrentStock.A_CurrentStockValue + ""
                    }
                  />
                </Grid>
                
              </Grid>
            ) : (
              <div className="d-flex justify-content-between">
                

                <span
                  className={
                    vRdxWmsHead.A_DocStat == "POST" ? "hide-all-time" : "d-flex"
                  }
                >
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"StockQty= " + sCurrentStock.A_CurrentStockQty + ""}
                  />{" "}
                  &nbsp; &nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={
                      "StockValue= " + sCurrentStock.A_CurrentStockValue + ""
                    }
                  />{" "}
                  &nbsp; &nbsp;
                </span>
              </div>
            )}
          </Grid>
        </Grid>
        {/* {!xMediaQuery && (
          <Grid item xs={6} sm={2} md={1} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="S.No"
              xValue={xBufferObj.B_Srno}
              xType={"text"} // text/number/password
              xName={"B_Srno"}
              xReadOnly={true}
              xOnChange={""}
              xError={xErrorMsgDetail.B_Srno === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Srno}
              // xOnKeyUp={xKey}
            />
          </Grid>
        )} */}
        <Grid item xs={3} sm={2} md={1} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"101"}
            xLabelText="Adj Type"
            xValue={xBufferObj.B_AdjType}
            xOnChange={fAdjType}
            xName={"B_AdjType"}
            xData={sAdjType}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_AdjType === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_AdjType}
            xDisable={false}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        {/* <Grid item xs={6} sm={2} md={2} lg={2} className="lastkeyDetect">
          <CmpTypographyField xcomponent={"div"} xText={"Card ID"} />
          <div className="d-flex">
            <CmpInputField
              xValue={xBufferObj.B_CardId}
              xType={"text"} // text/number/password
              xName={"B_CardId"}
              xReadOnly={sAdjTypeDependency.B_CardId}
              xOnChange={fCardId}
              xError={xErrorMsgDetail.B_CardId === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_CardId}
              xtabIndex={"102"}
              xOnKeyUp={fCardIdEnter}
            />
          </div>
        </Grid> */}
        <Grid item xs={9} sm={6} md={2} className="lastkeyDetect">
          <GCToggleSearchV1
            xLabelText="Card ID"
            xtabIndex={"102"}
            xName={"B_CardId"}
            xType={"number"}
            xValue={xBufferObj?.B_CardId}
            xReadOnly={sAdjTypeDependency.B_CardId}
            xOnChange={fCardId}
            xOnKeyUp={fCardIdEnter}
            xError={xErrorMsgDetail.B_CardId === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_CardId}
            xMediaQuery={xMediaQuery}
            xonClickbtn={fCardIdEnter}
          />
        </Grid>
        <Grid item xs={6} sm={2} md={2} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="SuppRefNo"
            xValue={xBufferObj.SuppRefNo1}
            xType={"text"} // text/number/password
            xName={"SuppRefNo1"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={6} sm={2} md={2} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={10}
          // md={"auto"}
          // lg={"auto"}
          // lg={"auto"}
          md={4}
          // lg={5}
          className="lastkeyDetect"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"103"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={sAdjTypeDependency.B_ItmName}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={2}   className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Batch"
            xtabIndex={"104"}
            xValue={xBufferObj.B_Batch}
            xType={"text"} // text/number/password
            xName={"B_Batch"}
            xReadOnly={sAdjTypeDependency.B_Batch}
            xOnChange={fBatch}
            xError={xErrorMsgDetail.B_Batch === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Batch}
            xonFocus={(e) => {
              xContent_Focus(e);
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1.8}  className="lastkeyDetect">
          <CmpDatePickerField001V1
            xLabelText="MDF"
            xtabIndex={"105"}
            xValue={xBufferObj.B_MDF}
            xOnChange={fMDF}
            xName={"B_MDF"}
            xError={xErrorMsgDetail.B_MDF === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_MDF}
            xDisable={sAdjTypeDependency.B_MDF}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1.8}  className="lastkeyDetect">
          <CmpDatePickerField001V1
            xLabelText="EXD"
            xtabIndex={"106"}
            xValue={xBufferObj.B_EXD}
            xOnChange={fEXD}
            xName={"B_EXD"}
            xmindate={xBufferObj.B_MDF}
            xError={xErrorMsgDetail.B_EXD === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_EXD}
            xDisable={sAdjTypeDependency.B_EXD}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1.4}  >
          <CmpTextFieldV1
            xLabelText="Bincode"
            xValue={xBufferObj.B_BinCode}
            xType={"text"} // text/number/password
            xName={"B_BinCode"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BinCode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinCode}
          />
        </Grid>
        <Grid item xs={8} sm={4} md={4} lg={4}>
          <GCToggleSearchV1
            xLabelText="Bin Name"
            xName={"GC_Toggle_Head_BinName_Name"}
            xType={"text"}
            xValue={xBufferObj.B_BinName}
            xReadOnly={sAdjTypeDependency.B_BinName}
            xOnChange={xfGC_Toggle_Head_BinName_Name} //GCToggleSearch onchange main input
            xOnKeyUp={xGC_Toggle_Head_BinName_onKeyUp} //GCToggleSearch xOnKeyUp main input
            xError={xErrorMsgDetail.B_BinName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinName}
            xMediaQuery={false}
            xonClickbtn={xGC_Toggle_Head_BinName_onKeyUp} // GCToggleSearch onclick icon open div on main screen
            xrows={xGC_Toggle_Head_BinName_GridData} //GCToggleSearch-grid
            xcolumns={xGC_Toggle_Head_BinName_GridColumns} //GCToggleSearch-grid
            xRowCellClick={xfGC_Toggle_Head_BinName_OnCellKeyDown}
            xRowClick={xfGC_Toggle_Head_BinName_OnRowClick}
            xToggle={xGC_Toggle_Head_BinName_Toggle} //GCToggleSearch- true/false
            xData={xGC_Toggle_Head_BinName_DropDown_Arr} //GCToggleSearch-select
            xOnChangeDropdownInput={xGC_Toggle_Head_BinName_Dropdown_onChange} //GCToggleSearch -input
            xDropdownObj={xGC_Toggle_Head_BinName_SearchDropdownObj} //GCToggleSearch -obj
            xOnKeyUpDropdownInput={
              xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load
            } //GCToggleSearch -Enter key and clickc detect
            xtabIndex="107"
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xtabIndex={"108"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={sAdjTypeDependency.B_Qty}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={(e) => {
              fKeyTabInput(e, "B_UnitCost");
            }}
            xonFocus={(e) => {
              xContent_Focus(e);
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1.5} className="lastkeyDetect">
          <CmpSelectFieldV1
            xtabIndex={"109"}
            xLabelText="Unit"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
            xonFocus={(e) => {
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText=" Unit Cost"
            xtabIndex={"110"}
            xValue={xBufferObj.B_UnitCost}
            xType={"number"} // text/number/password
            xName={"B_UnitCost"}
            xReadOnly={sAdjTypeDependency.B_UnitCost}
            xOnChange={fUnitCost}
            xError={xErrorMsgDetail.B_UnitCost === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_UnitCost}
            xonFocus={(e) => {
              xContent_Focus(e);
              fFocusShowSalesHistoryGrid(e);
            }}
            xonBlur={xContent_Blur}
            xOnKeyUp={(e) => fUnitCostSave_onKeyUp(e)}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Value"
            xtabIndex={"111"}
            xValue={xBufferObj.B_Value}
            xType={"text"} // text/number/password
            xName={"B_Value"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Value === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Value}
            // xOnKeyUp={xKey}
          />
        </Grid>
      </Grid>
    </form>
  );
}
